export const META_PIXEL_IDS = ["1879978779633280", "1018898824555070"];

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: Fbq;
  loaded: boolean;
  version: string;
};

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}

let initialized = false;

export function initMetaPixel() {
  if (initialized || typeof window === "undefined" || window.location.hostname !== "managers.stockdigital.shop") return;
  initialized = true;

  if (!window.fbq) {
    const fbq = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod(...args);
      } else {
        fbq.queue.push(args);
      }
    } as Fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];
    window.fbq = fbq;
    if (!window._fbq) window._fbq = fbq;

    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);
  }

  META_PIXEL_IDS.forEach((id) => window.fbq?.("init", id));
  window.fbq?.("track", "PageView");
}

export function trackPixelEvent(event: string, params?: Record<string, string | number>) {
  if (typeof window === "undefined" || window.location.hostname !== "managers.stockdigital.shop") return;
  window.fbq?.("track", event, params);
}
